'use client';

import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import InlineTruncationText from '@/components/inline-truncation-text';
import { focusVisibleOutline } from '@/lib/focus-styles';
import { cn } from '@/lib/utils';

const DEFAULT_COLLAPSED_ROWS = 2;
const DEFAULT_TEXT_CLASS_NAME = 'body-copy-l text-neutral-10 text-justify [text-align-last:left]';
const DEFAULT_WRAPPER_CLASS_NAME = 'flex w-full flex-col items-start gap-2';

export interface EditorialInlineTruncationTextProps {
    text: string;
    collapsedRows?: number;
    wrapperClassName?: string;
    textClassName?: string;
}

/**
 * Editorial truncation with PLP read more / read less labels and shared underline controls.
 */
export default function EditorialInlineTruncationText({
    text,
    collapsedRows = DEFAULT_COLLAPSED_ROWS,
    wrapperClassName = DEFAULT_WRAPPER_CLASS_NAME,
    textClassName = DEFAULT_TEXT_CLASS_NAME,
}: EditorialInlineTruncationTextProps): ReactElement | null {
    const { t } = useTranslation('categoryPlp');

    return (
        <InlineTruncationText
            text={text}
            readMoreLabel={t('readMore')}
            readLessLabel={t('readLess')}
            collapsedRows={collapsedRows}
            wrapperClassName={wrapperClassName}
            textClassName={textClassName}
            readMoreClassName={cn(
                'body-copy-l-bold cursor-pointer text-neutral-10 underline decoration-solid underline-offset-4 hover:opacity-80',
                focusVisibleOutline
            )}
            readLessClassName={cn(
                'body-copy-m cursor-pointer self-start text-neutral-10 underline decoration-solid underline-offset-4 hover:opacity-80',
                focusVisibleOutline
            )}
        />
    );
}
